import React, { useEffect, useRef, useState } from 'react';
import { classNames } from '../../utils/helpers';
import styles from './Accordion.module.scss';
export const Accordion = ({ children }) => (React.createElement("div", { className: styles.accordion }, children));
export const AccordionItem = ({ id, label, onOpen = () => undefined, onClose = () => undefined, onClick = () => undefined, collapse = false, expand = false, children, }) => {
    const inputRef = useRef(null);
    const bodyRef = useRef(null);
    const zeroHeightBodyWrapperRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const setInputRefValue = (val) => {
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            inputRef.current.checked = val;
        }
    };
    const expandItem = () => {
        if ((zeroHeightBodyWrapperRef === null || zeroHeightBodyWrapperRef === void 0 ? void 0 : zeroHeightBodyWrapperRef.current) && (bodyRef === null || bodyRef === void 0 ? void 0 : bodyRef.current)) {
            zeroHeightBodyWrapperRef.current.style.height = `${bodyRef.current.clientHeight}px`;
            setInputRefValue(true);
        }
    };
    const collapseItem = () => {
        if (zeroHeightBodyWrapperRef === null || zeroHeightBodyWrapperRef === void 0 ? void 0 : zeroHeightBodyWrapperRef.current) {
            zeroHeightBodyWrapperRef.current.style.height = `0px`;
            setInputRefValue(false);
        }
    };
    useEffect(() => {
        if (expand) {
            setExpanded(true);
        }
    }, [expand]);
    useEffect(() => {
        if (collapse) {
            setExpanded(false);
        }
    }, [collapse]);
    useEffect(() => {
        if (expanded) {
            expandItem();
        }
        else {
            collapseItem();
        }
    }, [expanded]);
    useEffect(() => {
        if (inputRef.current.checked) {
            expandItem();
        }
    }, [children]);
    const handleChange = ({ target: { checked }, }) => {
        onClick(id);
        if (children) {
            if (checked) {
                setExpanded(true);
                onOpen(id);
            }
            else {
                setExpanded(false);
                onClose(id);
            }
        }
    };
    return (React.createElement("div", { className: styles.accordionItem },
        React.createElement("input", { ref: inputRef, id: id, type: "checkbox", className: classNames(!!children && styles.transition), onChange: handleChange }),
        React.createElement("label", { htmlFor: id, className: styles.label },
            label,
            children ? (React.createElement("div", { className: `${styles.icon} ${styles.iconArrow}` })) : (React.createElement("div", { className: `${styles.icon} ${styles.iconNewTab}` }))),
        !!children && (React.createElement("div", { className: styles.zeroHeightBodyWrapper, ref: zeroHeightBodyWrapperRef, ...(!expanded && { inert: '' }) },
            React.createElement("div", { ref: bodyRef, className: styles.body }, children)))));
};
